/**
 * Paths layout form (e.g. selection-as-action, provenance-dag-branches).
 *
 * These are the architecture / model slides: a heading plus a vertical
 * stack of "path" cards each describing one branch. Keep bodyHtml as
 * the source of truth; the form's job is to remind the editor how each
 * path card should be structured.
 */

import type { Slide, SlideUpdatePayload } from "../types";
import { CommonSlideFields } from "./CommonSlideFields";
import { LayoutHint } from "./LayoutHint";
import { TextArea } from "./FormPrimitives";

interface PathsFormProps {
  draft: Slide;
  setField<K extends keyof SlideUpdatePayload>(
    key: K,
    value: SlideUpdatePayload[K],
  ): void;
  flush(): void;
}

export function PathsForm({ draft, setField, flush }: PathsFormProps) {
  return (
    <div data-testid="layout-form-paths">
      <LayoutHint title="Paths slide">
        Heading + a vertical stack of <code>.path</code> cards. Each card
        carries a label, a short description, and an optional inline
        snippet showing the lineage step.
      </LayoutHint>
      <CommonSlideFields draft={draft} setField={setField} flush={flush} />
      <TextArea
        label="Body HTML (heading + path cards)"
        value={draft.bodyHtml}
        onChange={(v) => setField("bodyHtml", v)}
        onBlur={flush}
        rows={14}
        testId="slide-body-html-input"
      />
    </div>
  );
}
